import * as React from "react";
import { List, Datagrid, TextField, DateField, TopToolbar, useRecordContext, useListContext, ListContextProvider } from 'react-admin';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
const DownloadButton = () => {
    const record = useRecordContext();
    if (!record?.URL) return null;
    return (
        <Button
            startIcon={<DownloadIcon />}
            variant="text"
            component="a"
            href={record.URL}
            download={record.Name}
            target="_blank"
            rel="noopener noreferrer"
        >
            Download
        </Button>
    );
};

// Normalizes uppercase ID → lowercase id so react-admin can track records correctly
const NormalizedDatagrid = () => {
    const listContext = useListContext();
    const normalizedData = React.useMemo(
        () => (listContext.data || []).map(r => ({ ...r, id: r.ID })),
        [listContext.data]
    );
    return (
        <ListContextProvider value={{ ...listContext, data: normalizedData }}>
            <Datagrid bulkActionButtons={false}>
                <TextField source="Name" label="Name" />
                <DateField source="created_at" label="Created at" locales="en-GB" showTime options={{ hour12: false }} />
                <DownloadButton label="Download" />
            </Datagrid>
        </ListContextProvider>
    );
};

const FileList = () => (
    <List
        actions={<TopToolbar />}
        sort={{ field: 'Name', order: 'ASC' }}
        storeKey={false}
        sx={{
            "& .MuiPaper-root": {
                overflow: { xs: 'scroll', md: 'auto' },
                width: { xs: '100vw', md: '100%' },
            },
        }}
    >
        <NormalizedDatagrid />
    </List>
);

export default FileList;
